import { INomenclatureData } from "Data/interfaces/Nomenclatura/INomenclatureData";
import { IDiscipline } from "Data/interfaces/Obra/IObraData";

export enum SettingsConfigEnum {
  validateStagesInNomenclature,
  allowOnlyStagesLinkedToDisciplinesInUpload,
  allowOnlyStagesLinkedToDisciplinesInTopics,
}
export interface InputStageProps {
  acronym: string;
  stageName: string;
}

export interface InputStageRequest {
  acronym: string;
  stageName: string;
  isDefault: boolean;
  disciplineIds: number[];
}

export interface IStages {
  csId: number;
  disciplines: IDiscipline[];
  versionConfigFk?: number;
  loading?: boolean;
  obraVersionData?: INomenclatureData;
  ValidateStagesInNomenclature: boolean;
  AllowOnlyStagesLinkedToDisciplinesInTopics: boolean;
  AllowOnlyStagesLinkedToDisciplinesInUpload: boolean;
}

export const headerStagesTable = [
  {
    id: '1',
    label: '#',
  },
  {
    id: '2',
    label: 'Sigla',
  },
  {
    id: '3',
    label: 'Etapa',
  },
  {
    id: '4',
    label: 'Disciplinas',
  },
  {
    id: '5',
    label: '',
  },
];
